module.exports = __webpack_public_path__ + "static/media/rnd1.2a2d6d80.jpg";